module.exports = __webpack_public_path__ + "img/logo.2d773ac3.png";